/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../../common/themes/themes';
import './Insurance.css';
import InsuranceListController from '../../../domain/myProfile/insurance/InsuranceList/InsuranceListController';
import ExpiredInsuranceController from '../../../domain/myProfile/insurance/ExpiredInsurance/ExpiredInsuranceController';
import { useAppSelector } from '../../../infra/hooks';

interface propInsurance {
  trans?: any;
  i18n?: any;
}

const InsurancePresenter = ({ trans, i18n }: propInsurance) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <Grid
      container
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        width: '100vw',
        marginTop: isHRView ? '' : '4em',
        paddingRight: '8em',
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: '#F5F5FA',
          width: '100%',
          padding: '1.75em',
          marginLeft:
            isHRView && i18n.language == 'en'
              ? '11em'
              : !isHRView && i18n.language == 'en'
                ? '14em'
                : '',
          marginRight: i18n.language == 'ar' ? '15em' : '',
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? '2em' : '',
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: '100%',
              height: '80px',
            }}
          >
            <Grid
              container
              style={{
                width: 'auto',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                borderRadius: '10px',
                opacity: '1',
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '1em',
                paddingBottom: '1em',
                paddingLeft: '1em',
                paddingRight: '1em',
              }}
            >
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.header,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Insurance')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid
              container
              spacing={3}
              style={{
                width: 'auto',
              }}
            >
              <Grid item xs={6} sm={6} md={6} lg={6}>
                <InsuranceListController />
              </Grid>

              <Grid item xs={6} sm={6} md={6} lg={6}>
                <ExpiredInsuranceController />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InsurancePresenter;
